export default "__VITE_ASSET__wCwfLQYw__"